export default {
      id: "icon-dropdown-arrow-usage",
      viewBox: "0 0 9.17 5.5",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-dropdown-arrow",
      toString: function () {
        return this.url;
      }
    }